import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 7 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.03466 0.155251L0.170386 5.61476C-0.0567949 5.82626 -0.0567949 6.17374 0.170386 6.38526L6.03466 11.8447C6.39401 12.1793 7 11.9375 7 11.4595L7 0.540506C7 0.0625437 6.39401 -0.1793 6.03466 0.155251Z",
      fill: "#EBEBEB"
    }, null, -1)
  ]))]))
}
export default { render: render }